import { render } from "./AccessibilityToggleProfil.vue?vue&type=template&id=b7848904"
import script from "./AccessibilityToggleProfil.vue?vue&type=script&lang=js"
export * from "./AccessibilityToggleProfil.vue?vue&type=script&lang=js"

import exportComponent from "/Users/francoisgillet/Documents/GitHub/tenjity-module/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__